import ApiResourceManager from '../ApiResourceManager';

export default class ScheduleExceptionManager extends ApiResourceManager {
  get = (companyId) =>
    this.request({
      method: 'GET',
      url: `/merchant/companies/${companyId}/schedule-exceptions`,
    });

  post = (companyId, data) =>
    this.request({
      method: 'POST',
      url: `/merchant/companies/${companyId}/schedule-exceptions`,
      data,
    });

  put = (id, data) =>
    this.request({
      method: 'PUT',
      url: `/merchant/schedule-exceptions/${id}`,
      data,
    });

  delete = (id) =>
    this.request({
      method: 'DELETE',
      url: `/merchant/schedule-exceptions/${id}`,
    });
}
